import React, { Fragment, useEffect } from "react";
import { render } from "react-dom";
import { Provider, useDispatch, useSelector } from "react-redux";
import { store } from "./redux/store";
import { getWaitCardsItemsData } from "./redux/slices/waitCardsItemsSlice";
import { getSettings } from "../../../../../scripts/util/getSettings";

const WaitTime = props => {
  const {
    clockwiseId,
    labels,
    isClosed
  } = props;
  const waitCardsItems = useSelector((state) => state.waitCardsItems);
  const dispatch = useDispatch();

  useEffect(() => {
    if (!isClosed) {
      dispatch(getWaitCardsItemsData({ hospitalId: clockwiseId }));
      const interval = setInterval(() => {
        dispatch(getWaitCardsItemsData({ hospitalId: clockwiseId }));
      }, 60000);
      return () => clearInterval(interval);
    }
  }, []);

  const waitTime = waitCardsItems.waitTimes[clockwiseId];

  return (
    <Fragment>
      <div className="wc_time">
        {waitTime && waitTime !== 'N/A' && !isClosed && <Fragment>
          {waitCardsItems.waitTimes[clockwiseId]} {waitCardsItems.waitTimes[clockwiseId] ? labels.waitTimeUnit : ''}
        </Fragment>}
        {(waitTime === 'N/A' || isClosed) && <Fragment>{labels.closed}</Fragment>}
      </div>
      {waitTime && waitTime !== 'N/A' && !isClosed && <div className="find_btn">
        <div className="wc_buttons">
          <a href={`https://www.clockwisemd.com/hospitals/${clockwiseId}/appointments/new`} target="_blank" className={'primary button'}>{labels.getInLine}</a>
        </div>
      </div>}
      {(waitTime === 'N/A' || isClosed) && <div className="wc_buttons">
        <button className={'secondary button'}>{labels.unavailable}</button>
      </div>}
    </Fragment>
  );
};

const Component = props => {
  const {
    id
  } = props;

  const settings = getSettings(['vmc', 'waitCards']).filter(x => x.id == id.replace('wait_cards_block_', ''))[0];
  const labels = settings.labels;
  const waitCardLocations = settings.waitCardLocations;

  return (
    <div className="time_cards accordion_location">
      <div>
        <input defaultChecked type="checkbox" id={id} />
        <label htmlFor={id} name={id}>
          <span className="label">{labels.title}</span>
        </label>
        <div className="accordion_content">
          <div className="accordion_content_inner">
            <div className="wc_text" dangerouslySetInnerHTML={{ __html: labels.topBlurb }}></div>
            <div className="wc_contain">
              {waitCardLocations && waitCardLocations.map((item, i) => {
                return (
                  <div className="wc_wrap" key={i}>
                    <div className="wc_top">
                      <h2>{labels.locationPrefix} <a href={item.Url}>{item.LocationName.split(' |')[0]}</a></h2>
                      <div className="wc_top_inner">
                        <div className="wc_top_left">
                          <p>{item.IsClosed ? labels.maintenanceClosedLabel : (item.LocationHours.IsClosed ? labels.closed : `Open today ${item.LocationHours.StartTime.replace(':00','')} - ${item.LocationHours.EndTime.replace(':00','')}` )}</p>
                          <div className="time_cards_direction">
                            <a className="wc_icon_center" href={item.DirectionsUrl} target="_blank">
                              {labels.getDirections}  <img width="10" height="10" className="wc_direction_icon" src="/assets/images/icon-right-arrow.svg" alt="" />
                            </a>
                          </div>
                        </div>
                        <div className="wc_top_right">
                          <div className="est_time">
                            <img className="wc_icon" src="/assets/images/icon-wait-times.svg" alt="" /> <span>{labels.estimatedWaitTime}</span>
                          </div>
                          <WaitTime clockwiseId={item.ClockwiseId} labels={labels} isClosed={item.IsClosed} />
                        </div>
                      </div>
                    </div>
                    {item.OptionalMessage && <div className="wc_bottom">
                      <img className="alert_info_icon" src="/assets/images/icon-info-2.svg" alt="" />
                      <p>{item.OptionalMessage}</p>
                    </div>}
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const waitCardsBlocks = document.querySelectorAll('.wait_cards_block');
for (let x = 0; x < waitCardsBlocks.length; x++) {
  const id = waitCardsBlocks[x].getAttribute('id');
  render(<Provider store={store}><Component id={id} /></Provider>,
    document.getElementById(id)
  );
}

